// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Livestream Modal */
.ott-modern-modal .modal-content {
    background: transparent;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);
    overflow: hidden;
    max-width: 720px;
    margin: 0 auto;
}

.modal-header-custom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: rgba(255, 255, 255, 0.03);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.modal-title-custom {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0;
    letter-spacing: -0.5px;
}

.btn-close-custom {
    background: transparent;
    border: none;
    color: inherit;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    cursor: pointer;
}

.btn-close-custom:hover {
    opacity: 0.85;
    transform: rotate(90deg);
}

/* List Container */
.stream-list-container {
    max-height: 70vh;
    overflow-y: auto;
    padding: 16px;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.stream-list-container::-webkit-scrollbar {
    width: 6px;
}

.stream-list-container::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
}

/* Stream Card */
.mini-stream-card-new {
    display: flex;
    gap: 24px;
    padding: 20px;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 18px;
    margin-bottom: 16px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(255, 255, 255, 0.05);
}

.mini-stream-card-new:hover {
    background: rgba(255, 255, 255, 0.07);
    border-color: rgba(255, 255, 255, 0.12);
    transform: translateX(4px);
    /* Subtle slide effect */
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
}

.mini-stream-card-new.is-live:hover {
    border-color: rgba(229, 9, 20, 0.3);
    box-shadow: 0 8px 30px rgba(229, 9, 20, 0.15);
}

.mini-thumb-new {
    position: relative;
    width: 200px;
    /* Reduced to a more balanced, standard size */
    aspect-ratio: 16/9;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
}

.mini-thumb-new img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
}

.mini-stream-card-new:hover .mini-thumb-new img {
    transform: scale(1.05);
}

/* Badges */
.badge-live,
.badge-upcoming {
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 6px;
    z-index: 2;
    backdrop-filter: blur(4px);
}

.badge-live {
    background: rgba(229, 9, 20, 0.9);
    color: #fff;
    box-shadow: 0 4px 12px rgba(229, 9, 20, 0.3);
}

.badge-upcoming {
    background: rgba(0, 123, 255, 0.9);
    color: #fff;
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.live-icon-blink {
    animation: blink 1.4s infinite;
}

.play-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    color: #fff;
    text-decoration: none;
}

.mini-stream-card-new:hover .play-overlay {
    opacity: 1;
}

/* Info Section */
.mini-info-new {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
    /* Ensures text truncation works */
}

.title-section {
    margin-bottom: 8px;
}

.stream-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: #fff;
    margin: 0 0 6px 0;
    letter-spacing: -0.2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stream-time {
    font-size: 0.9rem;
    color: #007bff;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(0, 123, 255, 0.1);
    padding: 4px 10px;
    border-radius: 6px;
    width: fit-content;
}

.stream-desc {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.6);
    margin: 0 0 16px 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.5;
}

/* Actions */
.btn-stream {
    display: inline-flex;
    align-items: center;
    padding: 8px 20px;
    border-radius: 10px;
    font-size: 0.9rem;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s ease;
}

.btn-live {
    color: inherit;
}

.btn-live:hover {
    opacity: 0.9;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    color: inherit;
}

.btn-upcoming {
    color: inherit;
}

.btn-upcoming:hover {
    opacity: 0.9;
    color: inherit;
}

/* Responsive */
@media (max-width: 600px) {
    .mini-stream-card-new {
        flex-direction: column;
        gap: 15px;
    }

    .mini-thumb-new {
        width: 100%;
    }

    .modal-header-custom {
        padding: 16px;
    }

    .stream-list-container {
        padding: 12px;
    }
}

@keyframes blink {
    0% {
        opacity: 1
    }

    50% {
        opacity: 0.3
    }

    100% {
        opacity: 1
    }
}

/* Preserve existing Age Warning Modal styles if any */
.age-warning-modal .modal-content {
    background: transparent;
    border: none;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
}

.ott-glass-container {
    background: rgba(15, 15, 15, 0.85);
    backdrop-filter: blur(25px) saturate(180%);
    -webkit-backdrop-filter: blur(25px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
    overflow: hidden;
    color: #fff;
    padding: 20px 16px;
    border-radius: 16px;
}

.design-elements {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
    z-index: 0;
}

.gradient-circle-1 {
    position: absolute;
    top: -20%;
    right: -10%;
    width: 250px;
    height: 250px;
    background: radial-gradient(circle, rgba(255, 0, 0, 0.15) 0%, transparent 70%);
    filter: blur(40px);
}

.gradient-circle-2 {
    position: absolute;
    bottom: -20%;
    left: -10%;
    width: 250px;
    height: 250px;
    background: radial-gradient(circle, rgba(235, 171, 10, 0.1) 0%, transparent 70%);
    filter: blur(40px);
}

.icon-badge-stack {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 0 auto;
}

.icon-glow-ring {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    border: 1.5px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 20px rgba(0, 123, 255, 0.1);
}

.shield-icon {
    color: #fff;
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));
}

.age-pill {
    position: absolute;
    bottom: 0;
    right: 0;
    background: #ff0000;
    color: #fff;
    font-weight: 800;
    font-size: 14px;
    padding: 4px 10px;
    border-radius: 12px;
    border: 2px solid #0f0f0f;
    box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
}

.modal-title-premium {
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -0.5px;
    background: linear-gradient(135deg, #fff 0%, #a5a5a5 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.modal-description-premium {
    font-size: 16px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.7);
    font-weight: 400;
}

.btn-ott-primary {
    border: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 15px;
    padding: 12px 22px;
}

.btn-ott-primary:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 24px rgba(255, 255, 255, 0.2);
    animation: pulse 2.5s infinite;
}

.btn-ott-primary:active {
    transform: scale(0.98);
}

.btn-ott-primary:focus-visible,
.btn-ott-secondary:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 3px;
}


.btn-ott-secondary {
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    font-size: 15px;
    padding: 12px 22px;
}

.btn-ott-secondary:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.2);
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
    }

    70% {
        box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/Popup.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,mBAAmB;IACnB,iDAAiD;IACjD,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,0BAA0B;IAC1B,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;IACnC,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,8CAA8C;IAC9C,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,WAAW;AACX;;IAEI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,6BAA6B;IAC7B,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA,sDAAsD;AACtD;IACI,uBAAuB;IACvB,YAAY;IACZ,gDAAgD;AACpD;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;IAC1C,kDAAkD;IAClD,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8EAA8E;IAC9E,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,aAAa;IACb,gFAAgF;IAChF,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,sDAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,0DAA0D;IAC1D,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iDAAiD;IACjD,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+CAA+C;IAC/C,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,0CAA0C;IAC1C,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;AAC1C;;AAEA;IACI;QACI,4CAA4C;IAChD;;IAEA;QACI,6CAA6C;IACjD;;IAEA;QACI,0CAA0C;IAC9C;AACJ","sourcesContent":["/* Modern Livestream Modal */\n.ott-modern-modal .modal-content {\n    background: transparent;\n    border-radius: 24px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);\n    overflow: hidden;\n    max-width: 720px;\n    margin: 0 auto;\n}\n\n.modal-header-custom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    background: rgba(255, 255, 255, 0.03);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.modal-title-custom {\n    font-size: 1.25rem;\n    font-weight: 700;\n    margin: 0;\n    letter-spacing: -0.5px;\n}\n\n.btn-close-custom {\n    background: transparent;\n    border: none;\n    color: inherit;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    cursor: pointer;\n}\n\n.btn-close-custom:hover {\n    opacity: 0.85;\n    transform: rotate(90deg);\n}\n\n/* List Container */\n.stream-list-container {\n    max-height: 70vh;\n    overflow-y: auto;\n    padding: 16px;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n}\n\n.stream-list-container::-webkit-scrollbar {\n    width: 6px;\n}\n\n.stream-list-container::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 10px;\n}\n\n/* Stream Card */\n.mini-stream-card-new {\n    display: flex;\n    gap: 24px;\n    padding: 20px;\n    background: rgba(255, 255, 255, 0.03);\n    border-radius: 18px;\n    margin-bottom: 16px;\n    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.mini-stream-card-new:hover {\n    background: rgba(255, 255, 255, 0.07);\n    border-color: rgba(255, 255, 255, 0.12);\n    transform: translateX(4px);\n    /* Subtle slide effect */\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);\n}\n\n.mini-stream-card-new.is-live:hover {\n    border-color: rgba(229, 9, 20, 0.3);\n    box-shadow: 0 8px 30px rgba(229, 9, 20, 0.15);\n}\n\n.mini-thumb-new {\n    position: relative;\n    width: 200px;\n    /* Reduced to a more balanced, standard size */\n    aspect-ratio: 16/9;\n    border-radius: 12px;\n    overflow: hidden;\n    flex-shrink: 0;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);\n}\n\n.mini-thumb-new img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.5s ease;\n}\n\n.mini-stream-card-new:hover .mini-thumb-new img {\n    transform: scale(1.05);\n}\n\n/* Badges */\n.badge-live,\n.badge-upcoming {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    padding: 6px 12px;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    z-index: 2;\n    backdrop-filter: blur(4px);\n}\n\n.badge-live {\n    background: rgba(229, 9, 20, 0.9);\n    color: #fff;\n    box-shadow: 0 4px 12px rgba(229, 9, 20, 0.3);\n}\n\n.badge-upcoming {\n    background: rgba(0, 123, 255, 0.9);\n    color: #fff;\n    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n}\n\n.live-icon-blink {\n    animation: blink 1.4s infinite;\n}\n\n.play-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    color: #fff;\n    text-decoration: none;\n}\n\n.mini-stream-card-new:hover .play-overlay {\n    opacity: 1;\n}\n\n/* Info Section */\n.mini-info-new {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-width: 0;\n    /* Ensures text truncation works */\n}\n\n.title-section {\n    margin-bottom: 8px;\n}\n\n.stream-title {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 6px 0;\n    letter-spacing: -0.2px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.stream-time {\n    font-size: 0.9rem;\n    color: #007bff;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: rgba(0, 123, 255, 0.1);\n    padding: 4px 10px;\n    border-radius: 6px;\n    width: fit-content;\n}\n\n.stream-desc {\n    font-size: 0.9rem;\n    color: rgba(255, 255, 255, 0.6);\n    margin: 0 0 16px 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    line-height: 1.5;\n}\n\n/* Actions */\n.btn-stream {\n    display: inline-flex;\n    align-items: center;\n    padding: 8px 20px;\n    border-radius: 10px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    text-decoration: none;\n    transition: all 0.2s ease;\n}\n\n.btn-live {\n    color: inherit;\n}\n\n.btn-live:hover {\n    opacity: 0.9;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n    color: inherit;\n}\n\n.btn-upcoming {\n    color: inherit;\n}\n\n.btn-upcoming:hover {\n    opacity: 0.9;\n    color: inherit;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n    .mini-stream-card-new {\n        flex-direction: column;\n        gap: 15px;\n    }\n\n    .mini-thumb-new {\n        width: 100%;\n    }\n\n    .modal-header-custom {\n        padding: 16px;\n    }\n\n    .stream-list-container {\n        padding: 12px;\n    }\n}\n\n@keyframes blink {\n    0% {\n        opacity: 1\n    }\n\n    50% {\n        opacity: 0.3\n    }\n\n    100% {\n        opacity: 1\n    }\n}\n\n/* Preserve existing Age Warning Modal styles if any */\n.age-warning-modal .modal-content {\n    background: transparent;\n    border: none;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7);\n}\n\n.ott-glass-container {\n    background: rgba(15, 15, 15, 0.85);\n    backdrop-filter: blur(25px) saturate(180%);\n    -webkit-backdrop-filter: blur(25px) saturate(180%);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    position: relative;\n    overflow: hidden;\n    color: #fff;\n    padding: 20px 16px;\n    border-radius: 16px;\n}\n\n.design-elements {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    overflow: hidden;\n    z-index: 0;\n}\n\n.gradient-circle-1 {\n    position: absolute;\n    top: -20%;\n    right: -10%;\n    width: 250px;\n    height: 250px;\n    background: radial-gradient(circle, rgba(255, 0, 0, 0.15) 0%, transparent 70%);\n    filter: blur(40px);\n}\n\n.gradient-circle-2 {\n    position: absolute;\n    bottom: -20%;\n    left: -10%;\n    width: 250px;\n    height: 250px;\n    background: radial-gradient(circle, rgba(235, 171, 10, 0.1) 0%, transparent 70%);\n    filter: blur(40px);\n}\n\n.icon-badge-stack {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin: 0 auto;\n}\n\n.icon-glow-ring {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1.5px solid rgba(255, 255, 255, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 0 20px rgba(0, 123, 255, 0.1);\n}\n\n.shield-icon {\n    color: #fff;\n    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));\n}\n\n.age-pill {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background: #ff0000;\n    color: #fff;\n    font-weight: 800;\n    font-size: 14px;\n    padding: 4px 10px;\n    border-radius: 12px;\n    border: 2px solid #0f0f0f;\n    box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);\n}\n\n.modal-title-premium {\n    font-size: 28px;\n    font-weight: 800;\n    letter-spacing: -0.5px;\n    background: linear-gradient(135deg, #fff 0%, #a5a5a5 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.modal-description-premium {\n    font-size: 16px;\n    line-height: 1.6;\n    color: rgba(255, 255, 255, 0.7);\n    font-weight: 400;\n}\n\n.btn-ott-primary {\n    border: none;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    font-size: 15px;\n    padding: 12px 22px;\n}\n\n.btn-ott-primary:hover {\n    transform: scale(1.02);\n    box-shadow: 0 8px 24px rgba(255, 255, 255, 0.2);\n    animation: pulse 2.5s infinite;\n}\n\n.btn-ott-primary:active {\n    transform: scale(0.98);\n}\n\n.btn-ott-primary:focus-visible,\n.btn-ott-secondary:focus-visible {\n    outline: 2px solid #fff;\n    outline-offset: 3px;\n}\n\n\n.btn-ott-secondary {\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    transition: all 0.3s ease;\n    font-size: 15px;\n    padding: 12px 22px;\n}\n\n.btn-ott-secondary:hover {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: rgba(255, 255, 255, 0.2);\n}\n\n@keyframes pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);\n    }\n\n    70% {\n        box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);\n    }\n\n    100% {\n        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
